import React from "react";

const Table = ({ children }) => {
  return (
    <div className="pl-5 pr-5 pb-5 text-base font-Inter font-medium flex justify-between border-[0.5px] border-[#E9EAEC] rounded  mt-10">
      {children}
    </div>
  );
};

export default Table;
